import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SEOHead() {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/seo-settings`)
      .then(res => setSeo(res.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!seo) return;

    // Update document title
    if (seo.site_title) document.title = seo.site_title;

    // Helper to set/update meta tags
    const setMeta = (name, content, property = false) => {
      if (!content) return;
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Standard meta tags
    setMeta('description', seo.meta_description);
    setMeta('keywords', seo.meta_keywords);
    setMeta('robots', seo.robots);

    // Open Graph
    setMeta('og:title', seo.og_title, true);
    setMeta('og:description', seo.og_description, true);
    setMeta('og:image', seo.og_image, true);
    setMeta('og:type', seo.og_type, true);
    if (seo.canonical_url) setMeta('og:url', seo.canonical_url, true);

    // Twitter
    setMeta('twitter:card', seo.twitter_card);
    setMeta('twitter:title', seo.og_title);
    setMeta('twitter:description', seo.og_description);
    setMeta('twitter:image', seo.og_image);

    // Canonical link
    if (seo.canonical_url) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', seo.canonical_url);
    }

    // Structured data (JSON-LD)
    if (seo.structured_data && Object.keys(seo.structured_data).length > 0) {
      let script = document.querySelector('script[data-seo="structured-data"]');
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.setAttribute('data-seo', 'structured-data');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(seo.structured_data);
    }

    // Custom head tags
    if (seo.custom_head_tags) {
      let container = document.querySelector('div[data-seo="custom-tags"]');
      if (!container) {
        container = document.createElement('div');
        container.setAttribute('data-seo', 'custom-tags');
        container.style.display = 'none';
        document.head.appendChild(container);
      }
      // Parse and inject custom tags
      const temp = document.createElement('div');
      temp.innerHTML = seo.custom_head_tags;
      const existingCustom = document.querySelectorAll('[data-custom-seo]');
      existingCustom.forEach(el => el.remove());
      Array.from(temp.children).forEach(el => {
        el.setAttribute('data-custom-seo', 'true');
        document.head.appendChild(el);
      });
    }
  }, [seo]);

  return null; // This component only manages document.head
}
